import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-oee-state-equipments',
  templateUrl: './oee-state-equipments.component.html',
  styleUrls: ['./oee-state-equipments.component.css']
})
export class OeeStateEquipmentsComponent implements OnInit {
    argType;

    argValue;

    public itemsListEquipments: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadEquipments() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListEquipments = await this.datatask.Post(243, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadEquipments();
    }

    ngOnInit() {
        this.init();
    }
}
